/** @jsx jsx */

import { jsx } from '@emotion/core';
import type { ReactNode } from 'react';

import EditorLayout from 'app/developer-v3/layouts/EditorLayout';
import type { SemVer } from 'app/developer-v3/types/version';
import { useCurrentVersionReadOnlyReason } from 'app/developer-v3/hooks';

import { getNav } from './utils';

type Props = {
  appId: string;
  children: ReactNode;
  currentUrl: string;
  hasLegacy: boolean;
  isStaff: boolean;
  isGUIIntegration: boolean;
  version: SemVer;
};

function AdvancedPage(props: Props) {
  const {
    appId,
    children,
    currentUrl,
    hasLegacy,
    isStaff,
    isGUIIntegration,
    version,
  } = props;

  const isReadOnly = !!useCurrentVersionReadOnlyReason();

  return (
    <EditorLayout
      currentUrl={currentUrl}
      isDisabled={isReadOnly}
      navConfig={getNav({
        appId,
        version,
        hasLegacy,
        isStaff,
        isGUIIntegration,
      })}
      title="Advanced"
    >
      {children}
    </EditorLayout>
  );
}

export default AdvancedPage;
